<template>
  <footer>
    <template v-if="user && user.portal == 'GLAD'">
      <div class="bg-light py-5">
        <b-container>
          <b-row>
            <b-col>
              <b-row>
                <b-col>
                  <a
                    href="https://gladswitzerland.ch/"
                    class="mt-2"
                    style="display: block;"
                  >
                    <img
                      src="../../assets/glad_logo.png"
                      style="max-width: 220px;"
                    />
                  </a>
                </b-col>
              </b-row>
              <b-row class="mt-5">
                <b-col>
                  Rheumafit&copy;, eine Platform von
                  <br />
                  <a
                    href="https://www.bechterew.ch"
                    class="mt-2"
                    style="display: block;"
                  >
                    <img
                      v-if="language === 'fr'"
                      src="../../assets/Bechterew_Logo_f_rgb2.svg"
                      style="width: 75%; max-width: 180px;"
                    />
                    <img
                      v-if="language === 'it'"
                      src="../../assets/Bechterew_Logo_i_rgb.svg"
                      style="width: 75%; max-width: 180px;"
                    />
                    <img
                      v-if="language === 'de'"
                      src="../../assets/Bechterew_Logo_d_rgb2.svg"
                      style="width: 75%; max-width: 180px;"
                    />
                    <img
                      v-if="language === 'en'"
                      src="../../assets/Bechterew_Logo_e_rgb.svg"
                      style="width: 75%; max-width: 180px;"
                    />
                    <img
                      v-if="language === 'bg'"
                      src="../../assets/Bechterew_Logo_e_rgb.svg"
                      style="width: 75%; max-width: 180px;"
                    />
                  </a>
                </b-col>
              </b-row>
            </b-col>
            <b-col v-if="!['xs', 'sm'].includes($mq)">
              <b>{{ $t('FOOTER_partner') }}</b>
              <br />
              <div class="my-2">
                <a href="https://www.rheumaliga.ch">
                  <img
                    v-if="language === 'fr'"
                    src="../../assets/Rheumaliga Schweiz_f_Grau.svg"
                    style="width: 70%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'de'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'it'"
                    src="../../assets/Rheumaliga Schweiz_i_Grau.svg"
                    style="width: 70%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'en'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'bg'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%; max-width: 120px;"
                  />
                </a>
              </div>
              <br />
              <a href="http://www.zhaw.ch">
                <img
                  src="../../assets/zhaw_gh_grau_cmyk_d.svg"
                  style="width: 70%; max-width: 120px;"
                />
              </a>
              <br />
              <br />
              <b>{{ $t('FOOTER_support') }}</b>
              <br />
              <a
                href="https://gesundheitsfoerderung.ch/"
                class="mt-2"
                style="display: block;"
              >
                <img
                  src="../../assets/gfs.png"
                  style="width: 100%; max-width: 220px;"
                />
              </a>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </template>
    <template v-else>
      <div class="bg-light py-5">
        <div class="container">
          <div class="row">
            <div class="col-6">
              <b>{{ $t('FOOTER_partner') }}</b>
              <br />
              <div class="my-2">
                <a href="https://www.rheumaliga.ch">
                  <img
                    v-if="language === 'fr'"
                    src="../../assets/Rheumaliga Schweiz_f_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'de'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'it'"
                    src="../../assets/Rheumaliga Schweiz_i_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'en'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'bg'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                </a>
              </div>
              <br />
              <a href="http://www.zhaw.ch">
                <img
                  src="../../assets/zhaw_gh_grau_cmyk_d.svg"
                  style="width: 70%;%; max-width: 120px;"
                />
              </a>
            </div>

            <div class="col-6">
              <b>{{ $t('FOOTER_support') }}</b>
              <br />
              <a
                href="https://gesundheitsfoerderung.ch/"
                class="mt-2"
                style="display: block;"
              >
                <img
                  src="../../assets/gfch_grey.png"
                  style="width: 100%; max-width: 220px;"
                />
              </a>
              <br />
              <a
                href="https://gesundheitsfoerderung.ch/"
                class="mt-2"
                style="display: block;"
              >
                <img
                  src="../../assets/mlr.svg"
                  style="width: 80%; max-width: 160px;"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row pt-2 pb-4" style="font-size: 12px; max-height: 24px;">
          <div class="col text-right">
            <feature name="faq" tag="span">
              <b-link :to="{ name: 'faq' }" class="pr-3">FAQ</b-link>
            </feature>
            <b-link :to="{ name: 'about' }" class="pr-3">
              {{ $t('about') }}
            </b-link>
            <LinkLegal target />
          </div>
        </div>
      </div>
    </template>
  </footer>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LinkLegal from '@/elements/links/Legal';

export default {
  name: 'footer-navigation',
  components: { LinkLegal },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['user']),
  },
};
</script>

<style scoped>
.link :hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterNavigation/mobile.vue